var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChefUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_21170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C8.79469 24 5.78123 22.7518 3.51469 20.4853C1.24823 18.2188 0 15.2053 0 12C0 8.79469 1.24823 5.78123 3.51469 3.51469C5.78123 1.24823 8.79469 0 12 0C15.2053 0 18.2188 1.24823 20.4853 3.51469C22.7518 5.78123 24 8.79469 24 12C24 15.2053 22.7518 18.2188 20.4853 20.4853C18.2188 22.7518 15.2053 24 12 24ZM12 1.875C6.41705 1.875 1.875 6.41705 1.875 12C1.875 17.583 6.41705 22.125 12 22.125C17.583 22.125 22.125 17.583 22.125 12C22.125 6.41705 17.583 1.875 12 1.875ZM11.9531 12.8906C9.4718 12.8906 7.45312 10.872 7.45312 8.39062C7.45312 5.9093 9.4718 3.89062 11.9531 3.89062C14.4345 3.89062 16.4531 5.9093 16.4531 8.39062C16.4531 10.872 14.4345 12.8906 11.9531 12.8906ZM11.9531 5.76562C10.5057 5.76562 9.32812 6.94322 9.32812 8.39062C9.32812 9.83803 10.5057 11.0156 11.9531 11.0156C13.4006 11.0156 14.5781 9.83803 14.5781 8.39062C14.5781 6.94322 13.4006 5.76562 11.9531 5.76562ZM17.8927 18.3503C18.2933 18.0222 18.3521 17.4315 18.024 17.0309C16.6983 15.4125 14.7396 14.4844 12.6499 14.4844H11.5376C9.44794 14.4844 7.48917 15.4125 6.16355 17.031C5.83547 17.4315 5.8942 18.0222 6.2948 18.3503C6.69534 18.6784 7.28602 18.6196 7.61414 18.2191C8.58211 17.0372 10.0122 16.3594 11.5376 16.3594H12.6499C14.1753 16.3594 15.6054 17.0372 16.5734 18.219C16.7588 18.4453 17.0279 18.5625 17.2992 18.5625C17.5082 18.5625 17.7185 18.493 17.8927 18.3503Z",
    fill: "#25AE35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_21170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefUser);
export default __webpack_public_path__ + "static/media/chef-user.eb6fb899a64f0ad1a2cdce0355d023e7.svg";
export { ForwardRef as ReactComponent };